// extracted by mini-css-extract-plugin
module.exports = {"idjdwyl":"idjdwyl","fadeOut":"fadeOut"};